import { getRowSize } from "./HelperFunctions";

export const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
export const rowSize = getRowSize();
export const numberOfRows = 4;
export const perfEntries = performance.getEntriesByType('navigation');